let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f9j1j")).then(() => parcelRequire('27N5H'));